// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import Faq from './Faq';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(Faq);
